var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gachi-skipnav"},[_c('li',{staticClass:"skipnav-item"},[_c('a',{attrs:{"href":"#container"}},[_vm._v("메인 바로가기")])])])
}]

export { render, staticRenderFns }